const SSE_CONFIG = {
  Odds: {
    topics: ["today_odds"],
  },

  Results: {
    topics: ["past_results"],
  },

  Dashboard: {
    topics: ["today_odds", "past_results"],
  },
  Rejected_links: {
    topics: ["rejected_links"],
  },
};

export default SSE_CONFIG;
